import React from 'react'
import {
	Row,
	Col,
	Image
} from 'react-bootstrap'

interface BannerProps {
  adsAndEvents: any
  locale: any
}

const Findjobs: React.FC<BannerProps> = (props: BannerProps) => {
	return (
		<>
			{props.adsAndEvents.map((event: any, index: number) => {
				return (event.type === 'Event' && event.banner ) ? (
					<Row key={index} style={index !== 0 ? { marginTop: '16px' } : {}}>
						<Col>
							<a target='_blank' href={`/${props.locale}/event/${event.id as string}`} rel='noreferrer'>
								<Image thumbnail style={{ borderRadius: '12px' }} src={event.banner} alt={`${event.name}`} />
							</a>
						</Col>
					</Row>
				) : (null)
			})}
			{props.adsAndEvents.map((event: any, index: number) => {
				return (event.type === 'Ads' && event.isActive) ? (
					<Row key={index} style={index !== 0 ? { marginTop: '16px' } : {}}>
						<Col>
							<a target='_blank' href={`${event.param}`} rel='noreferrer'>
								<Image thumbnail style={{ borderRadius: '12px' }} src={event.banner} alt={`${event.name}`} />
							</a>
						</Col>
					</Row>
				) : (null)
			})}
		</>
	)
}

export default Findjobs
